import React from "react";
const TwineIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 223.7 269.3"
  >
    <title>Twine</title>
    <g>
      <path
        className="st0"
        d="M44.3,163.6c-16.1-16.1-16.5-42.3-1.2-58.9l2.4-2.4c14.8-13.8,37.9-13.8,52.6,0.2l43.6,43.6
     c5.9,5.9,15.5,5.9,21.4,0l0,0c5.8-5.8,5.9-15.2,0.2-21.2L117,78.6c-13.2-13.2-13.2-34.7,0-47.9l0,0l4.6-4.6
     c5.1-5.1,5.1-13.3,0-18.3v0c-4.9-4.9-12.8-5-17.9-0.4l0,0l-0.4,0.4c0,0,0,0,0,0L75.6,35.4l0,0L23,88c-25,25-25,66,0,91l43.8,43.8
     c5.1,5.1,13.3,5.1,18.3,0c5.1-5.1,5.1-13.3,0-18.3L44.3,163.6z"
      />
      <path
        className="st0"
        d="M200.8,89l-16.1-16.1L157,45.3c-5.1-5.1-13.3-5.1-18.3,0c-5.1,5.1-5.1,13.3,0,18.3l40.8,40.8
     c14.9,14.9,16.4,38.2,4.6,54.8c-1.3,1.9-2.8,3.7-4.5,5.4h0c-15.2,15.2-39.8,15.2-54.9,0l0,0L83,122.9c-5.9-5.9-15.5-5.9-21.4,0
     c-5.8,5.8-5.9,15.2-0.2,21.2l0,0l44.4,44.4l0,0c13.7,13.7,13.7,36,0,49.8l-3.6,3.6c-5.1,5.1-5.1,13.3,0,18.3l0,0
     c5,5,13.1,5.1,18.1,0.2l0,0l0.2-0.2l27.6-27.6l0,0l52.6-52.6C225.8,155,225.8,114,200.8,89z"
      />
    </g>
  </svg>
);

export default TwineIcon;
